// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modular-carousel--container {\n  padding: 40px 50px; }\n\n.modular-carousel--movil-container {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  justify-content: center; }\n\n@media screen and (max-width: 760px) {\n  .modular-carousel--container {\n    padding: 40px 16px; } }\n", ""]);
// Exports
module.exports = exports;
